var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.labels.length)?_c('div',[_c('dt',[_vm._v(_vm._s(_vm._f("translate")(_vm.title)))]),_vm._v(" "),_c('dd',_vm._l((_vm.labels),function(ref){
var id = ref.id;
var name = ref.name;
return _c('span',{key:id,staticClass:"badge badge-pill badge-secondary mr-1",domProps:{"innerHTML":_vm._s(name)}})}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }